module.exports = __webpack_public_path__ + "static/media/jones-engineering.3b93d16c.png";